<template>
    <div class="common">
        <div class="spaceLeft">
            <span class="text-size-16 text-color-black" v-if="boundNum > 0">
                您已绑定 <span class="text-color-orange">{{boundNum}}</span> 个提现账户:（最多可绑定 <span class="text-color-orange">3</span> 个提现账户）
            </span>
            <span v-else>您还未绑定任何提现账户，请点击新增</span>
            <a-button :disabled="boundNum>=3" @click="toAdd('add')" class="btn-blue-line" style="margin-left:20px;">新增</a-button>
        </div>
        <div class="table-common">
            <a-table
                size="middle"
                :columns="columns"
                :data-source="tableData"
                :pagination="false"
                :loading="loading"
                :row-key="(record,index) => record.id+'_'+index"
                bordered
                :locale="{emptyText: '暂无数据'}"
            >
                <template slot="checkStCd" slot-scope="text">{{text | checkStCdTrans}}</template>
                <template slot="opertion" slot-scope="text,record">
                    <a @click="toAdd('detail',record)">查看</a>
                    <a
                        v-if="record.checkStCd === '1' || record.checkStCd === '2'"
                        href="javascript:void(0);"
                        @click="toAdd('edit',record)"
                    >变更</a>
                    <a
                        v-if="record.checkStCd === '1'"
                        href="javascript:void(0);"
                        @click="unbind(record.id)"
                    >解绑</a>
                </template>
            </a-table>
        </div>
    </div>
</template>

<script>
    import {getCstBindingAccountNum,bindingAccountList,invalidBindingAccount} from "@/api/customer.js"
    import {getCstIds} from "@/api/center.js"
    import {mapGetters} from "vuex"
    export default {
        name:"binding",
        components: {},
        data() {
            return {
                boundNum:0,
                cstId:"",
                columns: [
                    {
                        title:"开户银行",
                        dataIndex: "accBlngBnk"
                    },
                    {
                        title:"账户账号	",
                        dataIndex: "accNo",
                    },
                    {
                        title:"大额行号	",
                        dataIndex: "largeBankNo",
                    },
                    {
                        title:"状态	",
                        dataIndex: "checkStCd",
                        scopedSlots: { customRender: "checkStCd" }
                    },
                    {
                        title: "操作",
                        dataIndex: "opertion",
                        scopedSlots: { customRender: "opertion" }
                    },

                ],
                tableData: [],
                loading: false,
            };
        },
        computed: {
            ...mapGetters({
                userObj:"home/getUserObj",
                getUserHeader:"home/getUserHeader"
            })
        },
        created() {
            this.getTableData();
            this.getCstId();
        },
        mounted() {},
        methods: {
            getCstId(){
                getCstIds()
                .then(res => {
                    this.cstId = res.data && res.data.join(",");
                    this.getNum();
                })
                .catch(err => {
                    console.log(err);
                })
            },
            getNum(){
                const parm = {
                    cstId:this.cstId
                }
                getCstBindingAccountNum(parm,true)
                .then(res => {
                    this.boundNum = res.data;
                })
                .catch(err => {
                    console.log(err);
                })
            },
            getTableData(){
                this.loading = true;
                bindingAccountList()
                .then(res => {
                    this.loading = false;
                    this.tableData = res.data.grid.list||[];
                })
                .catch(err => {
                    this.loading = false;
                    console.log(err);
                })
            },
            toAdd(type,data){
                const id = data ? data.id : this.userObj.cstIds.join(",");
                this.MENUAPI.goToOneTab({
                    path:"account/add/",
                    query:{
                        type:type,
                        id:id
                    },

                })
            },
            unbind(id){
                let self = this;
                this.$confirm({
                    title: '解绑',
                    content: "是否确认解绑该账户？",
                    okText:"确认",
                    cancelText:"取消",
                    onOk() {
                        invalidBindingAccount({id}).then(res => {
                            self.$message.success("解绑成功");
                            self.getTableData();
                        });
                    }
                })
            }
        },
        watch: {},

    };
</script>
<style scoped>
    .table-common{
        margin-top: 20px;
    }
    a{
        margin-right: 5px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/account/binding/binding.vue